<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div class="w-full max-w-md">
      <div class="flex items-center justify-center gap-3 mb-8">
        <span class="w-11 h-11 rounded-xl bg-brand-600 text-white flex items-center justify-center text-xl">
          <font-awesome-icon icon="wind" />
        </span>
        <span class="font-extrabold text-2xl text-ink tracking-tight">
          Epi<span class="text-brand-600">Breath</span>
        </span>
      </div>

      <div class="card p-8">
        <h1 class="text-xl font-bold mb-1">Sign in</h1>
        <p class="text-sm text-ink-soft mb-6">Access the EpiBreath clinical dashboard.</p>

        <form @submit.prevent="onSubmit">
          <div class="mb-4">
            <label class="label" for="email">Email</label>
            <input
              id="email"
              v-model="email"
              type="email"
              autocomplete="username"
              class="input"
              placeholder="you@epibreath.local"
              required
            />
          </div>
          <div class="mb-5">
            <label class="label" for="password">Password</label>
            <input
              id="password"
              v-model="password"
              type="password"
              autocomplete="current-password"
              class="input"
              placeholder="••••••••"
              required
            />
          </div>

          <p v-if="error" class="text-sm text-red-600 mb-4">
            <font-awesome-icon icon="exclamation-triangle" class="mr-1" />
            {{ error }}
          </p>

          <button type="submit" class="btn btn-primary w-full h-11" :disabled="loading">
            <font-awesome-icon v-if="loading" icon="circle-notch" spin />
            <span>{{ loading ? 'Signing in…' : 'Sign in' }}</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getterTypes } from 'store/auth'

export default {
  data() {
    return { email: '', password: '' }
  },
  computed: {
    ...mapGetters({ error: getterTypes.error, status: getterTypes.status }),
    loading() {
      return this.status === 'loading'
    },
  },
  methods: {
    async onSubmit() {
      try {
        await this.$store.dispatch('auth/login', {
          email: this.email,
          password: this.password,
        })
        const redirect = this.$route.query.redirect || { name: 'Dashboard' }
        this.$router.push(redirect)
      } catch (e) {
        /* error surfaced via store */
      }
    },
  },
}
</script>
